import { fetchWithAuth } from "./FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;

export const GetAulaStats = async (id_user: string, id_aula: string, dataIni: string | null, dataFi: string | null) => {
    try {
        let url = `${apiUrl}:8061/usuaris/${id_user}/aules/${id_aula}/stats`;
        const params = new URLSearchParams();
        if (dataIni) params.append("dataIni", dataIni);
        if (dataFi) params.append("dataFi", dataFi);
        
        if (params.toString()) {
            url += `?${params.toString()}`;
        }
        
        const response = await fetchWithAuth(url);
        if (response && response.ok) {
            const jsonData = await response.json();
            return jsonData;
        }
        return null;
    } catch (error) {
        console.log('Error al obtener los estadisticas del aula:', error);
        return null;
    }
};
